export default "__VITE_ASSET__L_UJCVnV__"